/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 *
 * @returns {*}
 */
const StashedCartResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'stashedcarts/:thirdPartyRef',
        Object.assign(
            apiRequestParams.defaults(),
            {
                branchID: () => apiRequestParams.getAllUserBranchIDs().join(','),
            }
        ),
        {
            update: {
                method: 'PUT',
            },
        }
    );
};

module.exports = StashedCartResource;
